<template>
    <TxProductViewPortal>
<!--        <PosterTextLoader>-->
            <div class="lm-index" :class="[mapLayout,$root.env]">
<!--                <TxZoomControl-->
<!--                        v-model="zoom"-->
<!--                        :disabled="mapBlock"-->
<!--                        :mapLayout="mapLayout"-->
<!--                />-->
<!--                <TxZoomBlocker-->
<!--                        v-model="mapBlock"-->
<!--                        :mapLayout="mapLayout"-->
<!--                />-->
                <TxBlockOverlay :active="true">
                    <TxRendererProduct
                            componentName="TxProductBorder"
                            :mapLayout="mapLayout"
                            :size="mapSize"
                    >
                        <PosterTextProductWebGL/>
                    </TxRendererProduct>
                </TxBlockOverlay>
            </div>
<!--        </PosterTextLoader>-->
    </TxProductViewPortal>
</template>


<script>
    import PosterTextModule from "@packages/tx-products/products/poster-text/store-mixin";

    export default {
        name: 'PosterTextIndex',
        mixins: [PosterTextModule()],
        data() {
            return {
                mapBlock: false,
            }
        },
        mounted() {
            if (this.$root.env === 'admin') {
                this.mapBlock = true;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .lm-index {
        background: url(./assets/lm-background.webp);
        background-size: cover;
        position: relative;

        &.admin {
            padding-top: 40px !important;
            padding-bottom: 40px !important;
        }

        &.horizontal {
            background: none;
        }

        @media (max-width: 599px) {
            padding-bottom: 20px;
            background: none;
        }
        @media (min-width: 600px) {
            &.vertical {
                padding-top: 20px;
            }
        }
    }

</style>
